<template>
  <div class="header-table">
    <!-- Кабинеты -->
    <div class="cabinet-row" :style="rowStyle">
      <template v-for="roomEntry in roomsWithEmployees" :key="roomEntry.room.id">
        <div
          class="cabinet-cell"
          :style="{
            gridColumn: `span ${roomEntry.employees.length}`,
            width: empColWidth * roomEntry.employees.length + 'px'
          }"
        >
          {{ roomEntry.room.name }}
        </div>
      </template>
      <!-- Фейковый столбец справа для скролла -->
      <div v-if="scrollbarWidth" class="header-scroll-fake-scrollbar" :style="{ width: scrollbarWidth + 'px' }"></div>
    </div>
    <!-- Сотрудники -->
    <div class="employee-row" :style="rowStyle">
      <template v-for="roomEntry in roomsWithEmployees" :key="roomEntry.room.id">
        <template v-for="emp in roomEntry.employees" :key="emp.user_id">
          <div class="employee-cell" :style="{ width: empColWidth + 'px' }">
            <EmployeeAvatar :name="emp.user_name" :avatar-url="emp.avatar" />
            <span class="employee-name" :title="emp.user_name">{{ emp.user_name }}</span>
          </div>
        </template>
      </template>
      <!-- тот же фейковый столбец -->
      <div v-if="scrollbarWidth" class="header-scroll-fake-scrollbar" :style="{ width: scrollbarWidth + 'px' }"></div>
    </div>
  </div>
</template>

<script>
import EmployeeAvatar from '@/components/util/calendar/EmployeeAvatar.vue'

export default {
  name: "HeaderCabinetsAndEmployees",
  components: { EmployeeAvatar },
  props: {
    roomsWithEmployees: Array,
    empColWidth: { type: Number, default: 200 },
    scrollbarWidth: { type: Number, default: 16 }, // <--- принимаем ширину скролла как пропс
  },
  computed: {
    totalEmpCount() {
      return this.roomsWithEmployees.reduce((sum, r) => sum + r.employees.length, 0)
    },
    rowStyle() {
      // +1 столбец справа если нужен "фейк"
      const colCount = this.totalEmpCount + (this.scrollbarWidth ? 1 : 0)
      return {
        display: 'grid',
        gridTemplateColumns: `repeat(${colCount}, ${this.empColWidth}px)`
      }
    }
  }
}
</script>

<style scoped>
.header-scroll-fake-scrollbar {
  background: transparent;
  pointer-events: none;
  height: 100%;
}
.header-table {
  background: transparent;
  user-select: none;
}
.cabinet-row, .employee-row {
  width: 100%;
}
.cabinet-cell {
  background:
    linear-gradient(rgb(16 53 117 / 49%), rgb(16 53 117 / 49%)),
    linear-gradient(151deg, #15264e 0%, #030b1b 75%);
  color: var(--cal-text-primary);
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
  height: 48px;
  box-sizing: border-box;
  font-size: 18px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: inset 0 0 0 1px rgba(122, 164, 233, 0.16);
}
.employee-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  height: 42px;
  box-sizing: border-box;
  background:
    linear-gradient(rgb(16 53 117 / 49%), rgb(16 53 117 / 49%)),
    linear-gradient(151deg, #15264e 0%, #030b1b 75%);
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  box-shadow: inset 0 0 0 1px rgba(122, 164, 233, 0.12);
}
.employee-cell:last-child {
  border-right: none;
}
.employee-name {
  font-size: 13px;
  color: var(--cal-text-regular);
  margin-left: 10px;
  white-space: nowrap;          /* не переносить */
  overflow: hidden;             /* скрывать лишнее */
  text-overflow: ellipsis;      /* ... в конце */
  max-width: 120px;             /* подобрать подходящий размер */
  display: block;
  cursor: pointer;
}
</style>
